import React, { useEffect, useState, useCallback } from 'react'
import { Table, Spin, Alert, Button, notification } from 'antd'
import { ReloadOutlined, ReconciliationOutlined } from '@ant-design/icons'
import { CCard } from '@coreui/react'
import { apiRequest } from '../../helpers/apiRequest'

const apiUrl = process.env.REACT_APP_API

const CursValutar = () => {
  const [rates, setRates] = useState([])
  const [loading, setLoading] = useState(true)
  const [syncing, setSyncing] = useState(false)
  const [recalculating, setRecalculating] = useState(false)
  const [error, setError] = useState(null)

  const loadRates = useCallback(() => {
    setLoading(true)
    setError(null)
    apiRequest(`${apiUrl}curs-valutar`, 'GET')
      .then(res => setRates(res?.data || []))
      .catch(() => setError('Nu s-au putut încărca datele.'))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => { loadRates() }, [loadRates])

  const handleSync = async () => {
    setSyncing(true)
    try {
      const res = await apiRequest(`${apiUrl}curs-valutar/sync`, 'GET')
      notification.success({ message: `Sincronizat: ${res?.count ?? 0} zile importate` })
      loadRates()
    } catch {
      notification.error({ message: 'Eroare la sincronizare' })
    } finally {
      setSyncing(false)
    }
  }

  const handleRecalculate = async () => {
    setRecalculating(true)
    try {
      const res = await apiRequest(`${apiUrl}curs-valutar/recalculate`, 'POST')
      notification.success({
        message: 'Prețuri recalculate',
        description: `Oferte: ${res?.offers ?? 0} | Cereri: ${res?.rfqItems ?? 0} | Curs: ${res?.eurRate ?? '—'} RON/EUR`,
      })
    } catch {
      notification.error({ message: 'Eroare la recalculare' })
    } finally {
      setRecalculating(false)
    }
  }

  const columns = [
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
      render: (v) => new Date(v).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric' }),
    },
    {
      title: 'Curs EUR / RON',
      dataIndex: 'eur',
      key: 'eur',
      render: (v) => <strong>{Number(v).toFixed(4)}</strong>,
      align: 'right',
    },
  ]

  return (
    <CCard className="p-3">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h3 style={{ margin: 0 }}>Curs valutar EUR — BNR (ultima lună)</h3>
        <Button
          icon={<ReloadOutlined />}
          loading={syncing}
          onClick={handleSync}
        >
          Sincronizează ultimele 10 zile
        </Button>
        <Button
          icon={<ReconciliationOutlined />}
          loading={recalculating}
          onClick={handleRecalculate}
          type="primary"
        >
          Recalculează prețuri EUR
        </Button>
      </div>
      {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} />}
      {loading
        ? <Spin style={{ display: 'block', margin: '32px auto' }} />
        : (
          <Table
            dataSource={rates}
            columns={columns}
            rowKey="date"
            size="small"
            pagination={{ pageSize: 31, showSizeChanger: false }}
          />
        )
      }
    </CCard>
  )
}

export default CursValutar
